import { Box } from '@mui/material';

export const VaultColoredDot = ({ color }: { color?: string }) => {
  return (
    <Box padding='4px'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
      >
        <circle cx='8' cy='8' r='8' fill={color || 'transparent'} />
      </svg>
    </Box>
  );
};
